import {
    FETCH_USER_LIST
} from '../ActionTypes'

const INITIAL_STATE = {
    userList: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_USER_LIST:
            return { ...state, userList: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/UserManagementPage/UserManagementPageReducer.js